var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { injectable } from '../../../Data/Decorators/Injectable';
import { EventBus } from '../../../Data/EventBus/EventBus';
import { submitRouteParams } from '../../Hooks/UseRouteParams';
let CustomNavigator = class CustomNavigator {
    constructor() {
        this.events = new EventBus();
    }
    getScreenParams(routeName) {
        if (!this.events.has(routeName)) {
            this.events.next(routeName, { visible: false });
        }
        return this.events.get(routeName);
    }
    show(routeName, params) {
        this.events.next(routeName, { visible: true });
        submitRouteParams(routeName, params);
        return Promise.resolve(routeName);
    }
    hide(routeName) {
        this.events.next(routeName, { visible: false });
        return Promise.resolve(routeName);
    }
};
CustomNavigator = __decorate([
    injectable({ type: 'singleton' }),
    __metadata("design:paramtypes", [])
], CustomNavigator);
export { CustomNavigator };
